class sourceErrorCtrl {
    constructor($scope, httpRequest) {
        $scope.single = {}
        $scope.server = {}

        $scope.dictData = {}
        const typecodeArr = '["inv_type","is_list","zero_tax","is_privilege","invoice_nature","bill_status"]'
        httpRequest.get_dictByTypeArr(typecodeArr).then((res) => {
            $scope.dictData = res.data.value
            console.log($scope.dictData)
            $scope.dictData.is_red = [
                	{ enumTypeCode: null, enumName: '蓝票', enumCode: '0' },
                	{ enumTypeCode: null, enumName: '红票', enumCode: '1' },
            ]
            $scope.dictData.tax_includ = [
                { enumTypeCode: null, enumName: '不含税', enumCode: '0' },
                { enumTypeCode: null, enumName: '含税', enumCode: '1' },
            ]
        })
    }
}
sourceErrorCtrl.$inject = ['$scope', 'httpRequest']
export default sourceErrorCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/sourceError/sourceErrorCtrl.js